export default function Logo({ variant = "dark", compact = false, size }) {
  const dim = size || (compact ? 40 : 46);
  return (
    <div className="flex items-center gap-3" aria-label="UNISIC">
      <img
        src="/unisic-logo.png"
        alt="Logo UNISIC"
        width={dim}
        height={dim}
        className="object-contain flex-shrink-0"
        style={{ width: dim, height: dim }}
      />
      {!compact && (
        <div className="leading-tight">
          <div
            className="font-display font-bold tracking-tight text-[15px]"
            style={{ color: variant === "light" ? "#ffffff" : "#0A2E52" }}
          >
            UNISIC
          </div>
          <div
            className="text-[10px] uppercase tracking-[0.25em]"
            style={{ color: variant === "light" ? "#D4AF37" : "#64748B" }}
          >
            Recherche
          </div>
        </div>
      )}
    </div>
  );
}
